// extracted by mini-css-extract-plugin
export var header = "_ed-0";